import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component for page-specific meta tags
 * @param {string} title - Page title
 * @param {string} description - Page description
 * @param {string} image - OG image path (relative to public folder, e.g., "/og-images/programs.png")
 * @param {string} path - URL path (e.g., "/programs")
 */
function SEO({ title, description, image, path = '' }) {
  const siteUrl = 'https://beginthe.work';
  const fullUrl = `${siteUrl}${path}`;
  const fullTitle = title ? `${title} | Begin Strength` : 'Begin Strength';
  
  // Ensure image is an absolute URL
  const imageUrl = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : `${siteUrl}/social-media-image.png`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:url" content={fullUrl} />
    </Helmet>
  );
}

export default SEO;
